import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { MDBContainer } from 'mdbreact';
import { MDBSpinner } from 'mdb-react-ui-kit';
import MainContent from '../main-content/MainContent';
import HeaderContent from '../header/HeaderContent';
//import FooterContent from '../components/PageElements/FooterContent';
import ErrorPage from '../error-boundary/ErrorPage';
//import "bootstrap-css-only/css/bootstrap.min.css";
import { withOktaAuth } from '@okta/okta-react';
import SchedulerService from '../services/service';
import * as Constants from '../constants/constants';
import {
  BrowserRouter as Router, withRouter
} from "react-router-dom";
import IdleTimer from 'react-idle-timer'
import { UserContext } from '../contexts/UserContext';

export default withRouter(
  withOktaAuth(class Home extends Component {

    constructor(props) {
      super(props);
      if (this.props.authState.accessToken == undefined)
        //this.props.authService.logout('/');
        this.props.oktaAuth.signOut('/');
      this.idleTimer = null
      this.onIdle = this._onIdle.bind(this);
      this.state = {
        isValidUser: true,
        isLoading: true,
        isLoggedIn: false,
        user_name: null,
        user_full_name: null,
        user_profile: null,
        user_profile_okta: null,
        errorId: 0,
        errorDesc: '',
        active_tenant: {
          tenant_id: null,
          tenant_name: null,
          role: null,
          permissions: {
            isAdmin: false,
            canAccessURM:false,
            canCreateNewUser:false,
            canEditUser:false,

            canViewGroups:false,
            canAddGroups:false,
            canEditGroups:false,
            canDeleteGroups:false,

            canViewResources:false,
            canAddResources:false,
            canEditResources:false,
            canDeleteResources:false,

            canViewMeetings:false,
            canAddMeetings:false,
            canEditMeetings:false,
            canDeleteMeetings:false

          }
        },
        active_route: '/',
        refreshPage: { "modal": '', "value": false,date:null },
        
      }
    }

    toggleRefreshPage = (modalName,date=null) => {
      let refreshPage = {
          "modal": modalName,
          "value": !this.state.refreshPage?.value,
          date:date
      }
      this.setState({ refreshPage: refreshPage })
    }
    _onIdle(e) {

      //authService.logout();
      this.props.oktaAuth.signOut('/');
      this.setState({
        isLoggedOut: true,
        errorId: '440',
        errorDesc: 'Session is timed out. Please login again!'
      });

    }
    

    async componentDidMount() {
      try {
        this._isMounted = true;
        await this.props.oktaAuth.getUser()
          .then(response => {
            let name = response.name
            let email = response.email;

            //console.log("User Info :" + JSON.stringify(response));
            localStorage.setItem('user_email', email);
            //localStorage.setItem('user_name', name);
            localStorage.setItem('user_full_name', name);
            //localStorage.setItem('user_profile_okta', JSON.stringify(UserProfile));
            this.setState({ user_full_name: name }); //isLoading : false,

            SchedulerService.getData(Constants.SchedulerServiceBaseUrl + '/loggedInUser', 0)//"./user_data.json") 
              .then(response => {
                if (this._isMounted) {
                  //console.log("User Profile -->" + JSON.stringify(response));
                  if (response) { // (response.data && response.data.length > 0) {
                    let userProfile = response.data[0];// UserProfile; // response.json(); //data[0];
                    //if(userprofile )

                    let userId = userProfile?.user_id;
                    localStorage.setItem('user_id', userId);
                    localStorage.setItem('user_profile', JSON.stringify(userProfile));

                    var is_user_provisioner = userProfile?.is_user_provisioner;
                    var is_active_user = userProfile?.is_active;

                    if (!is_active_user) {
                      this.setState({
                        isValidUser: false,
                        isLoggedIn: false,
                        isLoading: false,
                        errorId: '401',
                        errorDesc: 'User is marked as inactive in the system. Please contact admin for SSCRIPTER application'
                      });
                    }
                    else {
                      if (is_user_provisioner) {
                        userProfile.default_tenant_id = 0;
                      }
                      this.setState({
                        isValidUser: true,
                        isLoading: false,
                        isLoggedIn: true,
                        user_name: userProfile.name,
                        user_profile: userProfile
                      });
                    }
                    this.processPermissions(userProfile, is_user_provisioner);
                  }
                  else {
                    this.setState({
                      isValidUser: false,
                      isLoggedIn: false,
                      isLoading: false,
                      errorId: '401',
                      errorDesc: 'User is not available in the system or marked as inactive. Please contact admin for SCHEDULER application'
                    });
                  }
                }
              },
                (err) => {
                  console.log('Service Error : Log In -> Getting User Profile ' + err);
                  this.setState({
                    isValidUser: false,
                    isLoggedIn: false,
                    isLoading: false,
                    errorId: '503',
                    errorDesc: 'User profile service is not available. Please try again and contact admin for SCHEDULER application'
                  });
                });


          },
            (err) => {
              console.log(err);
              this.setState({
                isValidUser: false,
                isLoggedIn: false,
                isLoading: false,
                errorId: '503',
                errorDesc: 'OKTA user profile service is not available. Please try again and contact admin for SCHEDULER application'
              });
            });
      }
      catch (err) { }
    }
    processPermissions(userProfile, is_user_provisioner) {

      //let permissions = appConstants.PERMISSIONS;
      //let permissionObjs = [];
      if (userProfile) {
        // debugger;
        let tenants = [];
        var default_tenant_id = 1; // userProfile.default_tenant_id;
        var active_tenant = localStorage.getItem("active_tenant_id");
        var active_tenant_name = localStorage.getItem("active_tenant_name");
        var active_tenant_role;
        // this.setState({ tenants: userProfile.last_logged_at });
        // userProfile.last_logged_at.forEach((tenant) => {
        this.setState({ tenants: userProfile.user_roles });
        userProfile.user_roles.forEach((tenant) => {
          if (tenant.tenant_id == null) {
            tenant.tenant_id = 0;
            tenant.tenant_name = "All Tenants";
          }
          tenants.push({
            "tenant_id": tenant.tenant_id,
            "tenant_name": tenant.tenant_name
          });
          localStorage.setItem("tenants", JSON.stringify(tenants));

          if ((active_tenant == "null" || !active_tenant) && default_tenant_id == tenant.tenant_id) {
            localStorage.setItem("active_tenant_id", tenant.tenant_id);
            localStorage.setItem("active_tenant_name", tenant.tenant_name);
            active_tenant = tenant.tenant_id;
          }

          
          if (active_tenant == tenant.tenant_id || userProfile.is_user_provisioner === 1) {
            this.processPermissionsforTenant(tenant, is_user_provisioner);
          }
          //permissionObjs.push(permObj);
        });
        //localStorage.setItem("permissions", permissionObjs);     

      }

    }


    processPermissionsforTenant(tenant, is_user_provisioner) {
      var isAdmin = false;      
      var active_tenant_id = tenant.tenant_id;
      var active_tenant_name = tenant.tenant_name;
      var active_tenant_role = tenant.role_name;
    
      let  active_tenant = { ...this.state.active_tenant };
      let  permissions = active_tenant.permissions;

      tenant.permissions.map((permission) => {
        if (permission?.permission_name) {
          switch (permission?.permission_name) {
            case 'Can access User Role Management': permissions.canAccessURM = true;break;
            case 'Can create new users':permissions.canCreateNewUser = true;break;
            case 'Can edit existing users' : permissions.canEditUser = true;break;
            case 'Can view Groups': permissions.canViewGroups = true; break;
            case 'Can create new Groups':permissions.canAddGroups = true; break;
            case 'Can edit Groups': permissions.canEditGroups = true; break;
            case 'Can delete groups': permissions.canDeleteGroups = true; break;

            case 'Can view Resources':permissions.canViewResources = true; break;
            case 'Can edit Resources': permissions.canEditResources = true; break;
            case 'Can delete Resource': permissions.canDeleteResources = true; break;
            case 'Can create new Resources' :permissions.canAddResources = true; break;

            case 'Can view meetings': permissions.canViewMeetings = true; break;
            case 'Can schedule a meeting': permissions.canAddMeetings = true; break; 
            case 'Can edit a meeting' : permissions.canEditMeetings = true; break;  
            case 'Can delete a meeting' : permissions.canDeleteMeetings = true; break;    
          }
        }
        // if (is_user_provisioner === 1) {
        //   permissions.isManageUser = true;
        // }

        // if (is_user_provisioner) {
        //   active_tenant_role = "User Provisioner";
        //   }

      });

      active_tenant.tenant_id = active_tenant_id;
      active_tenant.tenant_name = active_tenant_name;
      active_tenant.role = active_tenant_role;
      active_tenant.permissions = permissions;

      console.log("User Profile - Active Tenant:" + JSON.stringify(active_tenant));

      this.setState({       
        active_tenant: active_tenant
      });

      localStorage.setItem("active_tenant_id", tenant.tenant_id);
      localStorage.setItem("active_tenant_name", tenant.tenant_name);
     
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    // handleSideNavActive = (value, routePath) => {       
    //   //this.props.history.push(routePath);
    //   //this.props.handleSideNavActive(value, routePath);
    //   //this.setState({active_route : routePath});
    //   this.mainContent.current.handleSideNavActive1(value, routePath);
    // }

    // handleSideNavActive1 = (value, routePath) => {
    //   this.mainContent.current.handleSideNavActive1(value, routePath);
    // }

    switchTenant = (tenant_id) => {
      //alert("Switched to Tenant -->"+tenant_id);
      var tenant = this.state.user_profile.user_roles.find(tenant => tenant.tenant_id == tenant_id);
      this.processPermissionsforTenant(tenant, this.state.user_profile.is_user_provisioner);
      this.props.history.push('/', this.state);
      window.location.reload();
    }

    render() {
      return (
        (this.state.isLoading ?

          <div className='alignCenter '>
            <div className="align-center-vertical">
              <MDBSpinner role='status' color="primary">
              </MDBSpinner>
              <div>
                <span style={{ textAlign: 'center' }}>Loading SCHEDULER....</span>
              </div>
            </div>
          </div>

          : (
            !this.state.isValidUser ?
              <ErrorPage isLoggedIn={this.state.isValidUser} errorId={this.state.errorId}
                errorDesc={this.state.errorDesc} ></ErrorPage>
              :

              <>
                <IdleTimer
                  ref={ref => { this.idleTimer = ref }}
                  element={document}
                  onIdle={this.onIdle}
                  debounce={250}
                  timeout={1000 * 60 * Constants.IDLE_TIMEOUT} />
                <UserContext.Provider value={{
                  user_profile: this.state.user_profile,
                  active_tenant: this.state.active_tenant,
                  switchTenant: this.switchTenant.bind(this)
                }}>
                  {/* <Router> */}
                    <div className="h-100">
                      <HeaderContent {...this.state} toggleRefreshPage={this.toggleRefreshPage.bind(this)}
                        authState={this.props.authState} switchTenant={this.switchTenant.bind(this)} />

                     <MainContent {...this.state} {...this.props}
                        {...this.functions}
                        toggleRefreshPage={this.toggleRefreshPage.bind(this)}
                        wrappedComponentRef={this.mainContent}
                        switchTenant={this.switchTenant.bind(this)} />
             
                    </div>
                  {/* </Router> */}
                </UserContext.Provider>
              </>
          )
        )
      );
    }
  }
  )
);
